import { Card, CardContent } from "../ui/card";
import {
  Users,
  Clock,
  Star,
  Car,
  Shield,
  Heart,
  Award,
  MapPin,
  Route,
} from "lucide-react";
import { ImageWithFallback } from "../figma/ImageWithFallback";
import { useTranslation } from "react-i18next";
import "./AboutSection.css";
import { Helmet } from "react-helmet-async";

export function AboutSection() {
  const { t } = useTranslation();

  const stats = [
    {
      icon: <Users />,
      number: "1000+",
      label: t("about.stats.clients"),
    },
    {
      icon: <Route />,
      number: "PT + ES",
      label: t("about.stats.routes"),
    },
    {
      icon: <Clock />,
      number: "24/7",
      label: t("about.stats.service"),
    },
    {
      icon: <Star />,
      number: "4.9",
      label: t("about.stats.rating"),
    },
  ];

  const values = [
    {
      icon: <Clock />,
      title: t("about.values.commitment.title"),
      description: t("about.values.commitment.description"),
      gradient: "rapidez",
    },
    {
      icon: <Car />,
      title: t("about.values.comfort.title"),
      description: t("about.values.comfort.description"),
      gradient: "excelencia",
    },
    {
      icon: <Shield />,
      title: t("about.values.safety.title"),
      description: t("about.values.safety.description"),
      gradient: "seguranca",
    },
  ];

  const certifications = [
    "CAE: 93293",
    "RNAAT: 338/2018",
    "RNAVT: 8171",
    "RNAVT nº 8171",
    t("about.certifications.updated"),
  ];

  return (
    <>
    <Helmet>
      <title>{t("seo.about.title")}</title>

      <meta
        name="description"
        content={t("seo.about.description")}
      />

      <link
        rel="canonical"
        href="https://francescotransfers.com/about"
      />
    </Helmet>
    <div className="about-section">
      <section className="about-hero">
        <div className="about-hero-bg"></div>

        <div className="container">
          <div className="about-hero-text">
            <div className="badge">
              <Heart />
              <span>{t("about.hero.badge")}</span>
            </div>

            <h1 className="title">
              <span className="highlight">
                {t("about.hero.titleHighlight")}
              </span>

              <br />

              <span className="foreground">
                {t("about.hero.title")}
              </span>
            </h1>

            <p className="subtitle">
              {t("about.hero.subtitle")}
            </p>
          </div>

          <div className="stats-grid">
            {stats.map((stat, i) => (
              <div key={i} className="stat-item">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-story">
        <div className="container story-grid">
          <div>
            <h2>{t("about.story.title")}</h2>

            <div className="story-text">
              <p>{t("about.story.paragraph1")}</p>

              <p>{t("about.story.paragraph2")}</p>

              <p>{t("about.story.paragraph3")}</p>
            </div>
          </div>

          <div className="story-image">
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1495150434753-f8ceb319e9dc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixlib=rb-4.1.0&q=80&w=1080"
              alt={t("about.story.imageAlt")}
              className="image"
            />

            <div className="story-image-overlay"></div>
          </div>
        </div>
      </section>

      <section className="about-region">
        <div className="container region-card">
          <div className="region-icon">
            <MapPin />
          </div>

          <div>
            <h2>{t("about.region.title")}</h2>

            <p>{t("about.region.paragraph1")}</p>

            <p>{t("about.region.paragraph2")}</p>
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="container">
          <div className="section-header">
            <h2>{t("about.valuesSection.title")}</h2>

            <p>{t("about.valuesSection.subtitle")}</p>
          </div>

          <div className="values-grid">
            {values.map((value, i) => (
              <Card key={i} className={`value-card ${value.gradient}`}>
                <div className="top">
                  <div className="value-icon">{value.icon}</div>
                  <h3>{value.title}</h3>
                </div>

                <div className="bottom">
                  <CardContent>
                    <p>{value.description}</p>
                  </CardContent>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="about-certifications">
        <div className="container">
          <div className="section-header">
            <h2>{t("about.certifications.title")}</h2>

            <p>{t("about.certifications.subtitle")}</p>
          </div>

          <div className="certifications-grid">
            {certifications.map((cert, i) => (
              <div key={i} className="cert-item">
                <div className="cert-icon">
                  <Award />
                </div>

                <span>{cert}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-mission">
        <div className="container text-center">
          <h2>{t("about.mission.title")}</h2>

          <p>{t("about.mission.description")}</p>
        </div>
      </section>
    </div>
    </>
  );
}